// extracted by mini-css-extract-plugin
export default {"Title":"CanopyConfiguration_Title__c3G-O","Row":"CanopyConfiguration_Row__skb51"};